import { render, staticRenderFns } from "./CardCamera.vue?vue&type=template&id=51a595e4"
import script from "./CardCamera.vue?vue&type=script&lang=js"
export * from "./CardCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports